{
  "$schema": "http://json-schema.org/draft-07/schema",
  "type": "object",
  "title": "General Document",
  "description": "Common variables needed for all types of documents.",
  "properties": {
    "warrant_exercise": {
      "$ref": "#/definitions/warrant_exercise"
    },
    "user": {
      "$ref": "#/definitions/user"
    },
    "share_transfer": {
      "$ref": "#/definitions/share_transfer"
    },
    "share_repurchase": {
      "$ref": "#/definitions/share_repurchase"
    },
    "resolution": {
      "$ref": "#/definitions/resolution"
    },
    "vesting_schedule": {
      "$ref": "#/definitions/vesting_schedule"
    },
    "option_plan": {
      "$ref": "#/definitions/option_plan"
    },
    "option_grant": {
      "$ref": "#/definitions/option_grant"
    },
    "option_exercise": {
      "$ref": "#/definitions/option_exercise"
    },
    "investor_signatory": {
      "$ref": "#/definitions/investor_signatory"
    },
    "investor": {
      "$ref": "#/definitions/investor"
    },
    "filing": {
      "$ref": "#/definitions/filing"
    },
    "share_class": {
      "$ref": "#/definitions/share_class"
    },
    "stakeholder_relationship": {
      "$ref": "#/definitions/stakeholder_relationship"
    },
    "jurisdiction": {
      "$ref": "#/definitions/jurisdiction"
    },
    "company": {
      "$ref": "#/definitions/company"
    },
    "commitment": {
      "$ref": "#/definitions/commitment"
    },
    "signatory": {
      "$ref": "#/definitions/signatory"
    },
    "vesting_event": {
      "$ref": "#/definitions/vesting_event"
    },
    "share_issuance": {
      "$ref": "#/definitions/share_issuance"
    },
    "location": {
      "$ref": "#/definitions/location"
    },
    "name_fields": {
      "$ref": "#/definitions/name_fields"
    },
    "stakeholder": {
      "$ref": "#/definitions/stakeholder"
    },
    "sign_tab": {
      "$ref": "#/definitions/sign_tab"
    },
    "authorized_signatory": {
      "$ref": "#/definitions/authorized_signatory"
    },
    "address": {
      "$ref": "#/definitions/address"
    },
    "ceo": {
      "$ref": "#/definitions/ceo"
    },
    "shareholder": {
      "$ref": "#/definitions/shareholder"
    },
    "stakeholders": {
      "$ref": "#/definitions/stakeholders"
    },
    "book": {
      "$ref": "#/definitions/book"
    },
    "section": {
      "$ref": "#/definitions/section"
    }
  },
  "additionalProperties": false
}
